<template>
  <div v-if="isFiltered" class="container">
    <div class="row flex-wrap row--no-bottom gutter-sm">
      <component
        :is="cardComponent"
        v-for="card in blok"
        :key="card.id"
        :blok="card"
        card-type="horizontal"
        class="xs-12 sm-6"
      />
    </div>
  </div>
  <div v-else class="container">
    <div class="row flex-wrap row--match-height">
      <div class="column sm-12 lg-7">
        <div class="row flex-wrap gutter-sm">
          <component
            :is="cardComponent"
            v-for="card in blok.slice(0, 2)"
            :key="card.id"
            :blok="card"
            card-type="featured"
            class="xs-12 sm-12"
          />
        </div>
      </div>
      <div class="column sm-12 lg-5">
        <div class="row flex-wrap gutter-xs">
          <component
            :is="cardComponent"
            v-for="card in blok.slice(2, 5)"
            :key="card.id"
            :blok="card"
            :hide-introduction="true"
            card-type="horizontal"
            class="xs-12 sm-6 lg-12"
          />
        </div>
      </div>
    </div>
    <div class="row flex-wrap row--no-bottom gutter-xs">
      <component
        :is="cardComponent"
        v-for="card in blok.slice(5, -1)"
        :key="card.id"
        :blok="card"
        card-type="horizontal"
        class="xs-12 sm-6"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PageStoryblok } from '~/types/storyblok'
const props = withDefaults(
  defineProps<{
    blok?: PageStoryblok[]
    contentType?: string
    isFiltered?: boolean
  }>(),
  {
    blok: () => [],
    contentType: '',
    isFiltered: false,
  },
)

/**
 * The sub cards component type
 * Taken from the content type, in Camel case, with `Card` suffix
 * e.g `ServiceProvidersCard`
 */
const cardComponent = computed(
  () => unslugify(props.contentType).replace(/\W/g, '') + 'Card',
)
</script>

<style lang="less" scoped>
// stuff
</style>
